import React from 'react'
import { Pressable, StyleSheet, TouchableOpacity, View } from 'react-native'
import { tierName } from '@ppwr/convex/badges/catalog'
import { DS } from '../../design-system'
import { BadgeArt } from '../../../assets/badges/badgeAssets'
import { TIER_PALETTES } from '../../../assets/badges/palettes'
import { gridPalette, type BadgeDisplayState } from './badgeDisplay'

const ART_SIZE = 120

interface BadgeGridItemProps {
  state: BadgeDisplayState
  onPress: (state: BadgeDisplayState) => void
  onReset?: (state: BadgeDisplayState) => void
}

export const BadgeGridItem: React.FC<BadgeGridItemProps> = ({ state, onPress, onReset }) => (
  <TouchableOpacity style={styles.item} activeOpacity={0.7} onPress={() => onPress(state)}>
    {onReset ? (
      <Pressable style={styles.adminReset} hitSlop={8} onPress={() => onReset(state)}>
        <DS.Text variant="Body Large/Regular" color="Brand/Blue">
          R
        </DS.Text>
      </Pressable>
    ) : null}
    <View>
      <BadgeArt
        badge={state.badge}
        palette={gridPalette(state)}
        size={ART_SIZE}
        nextPalette={
          state.progressToNextTier === null ? undefined : TIER_PALETTES[tierName(state.badge, state.tier + 1)]
        }
        progressToNextTier={state.progressToNextTier}
      />
      {state.isComplete ? (
        <View style={styles.completeCheck}>
          <DS.Icon name="Check--enclosed" size={26} color="Utility/Success" />
        </View>
      ) : null}
    </View>
    <DS.Text variant="Body Small/Medium" textAlign="center" numberOfLines={2}>
      {state.badge.name}
    </DS.Text>
    {state.tierName ? (
      <DS.Text variant="Caption/Bold" color="Brand/Dark Grey">
        {state.tierName}
      </DS.Text>
    ) : null}
    {state.progressLabel ? (
      <DS.Text variant="Caption/Regular" color="Brand/Dark Grey">
        {state.progressLabel}
      </DS.Text>
    ) : null}
  </TouchableOpacity>
)

const styles = StyleSheet.create({
  item: {
    // Fixed halves (not space-between) so a partial row fills column 1
    // from the left instead of spreading to the edges.
    width: '50%',
    paddingHorizontal: DS.spacing[8],
    alignItems: 'center',
    gap: DS.spacing[4],
    marginBottom: DS.spacing[16]
  },
  completeCheck: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 13
  },
  adminReset: {
    position: 'absolute',
    top: 0,
    right: DS.spacing[8],
    zIndex: 1
  }
})
